'use strict';

angular.module('sharecrf-url', [])
    .service('ShareCrfUrl', ['$window', function($window) {
        function buildUrl(prefix, suffix) {
            var hostParts = $window.location.host.split('.');
            hostParts.shift();
            hostParts.unshift(prefix);

            var url = $window.location.protocol + '//' + hostParts.join('.') + '/';

            if (suffix) {
                url += suffix + '/';
            }

            return url;
        }

        return {
            getWww: function() {
                return buildUrl('www');
            },
            getPortal: function() {
                return buildUrl('portal');
            },
            getControlPanel: function(studySubdomain) {
                return buildUrl(studySubdomain, 'control-panel');
            },
            getStudyLive: function(studySubdomain) {
                return buildUrl(studySubdomain, 'live');
            },
            getStudyTest: function(studySubdomain) {
                return buildUrl(studySubdomain, 'test');
            },
            getDomain: function() {
                var hostParts = $window.location.host.split(':');
                hostParts = hostParts[0].split('.');
                hostParts.shift();

                return hostParts.join('.');
            },
        };
    }]);
